/* libs */
import React from "react";
import PropTypes from "prop-types";

/* components */
import { ShadowInput } from "../../../../../components/shared/Forms";

const Extras = () => {
	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					<ShadowInput field="shadows" id="shadows" placeholder="Shadows" />
				</div>
			</div>
		</div>
	);
};

Extras.propTypes = {
	prefix: PropTypes.string,
	showBorders: PropTypes.bool,
};

export default Extras;
